export const GA4ID = process.env.GATSBY_GA_ID || '';
